import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Control from "../Control";
import DualRange from "../DualRange";
import Dropdown from "../Dropdown/Dropdown";
import SelectTeamMember from "../SelectTeamMember/SelectTeamMember";

const TeamMemberForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange, addNewItem}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Team Member' : 'Add Team Member'}</div>
                <SelectTeamMember theme={theme}
                    value={data.arcimedes_row_id}
                    valueKey='arcimedes_row_id'
                    label='Name'
                    data={data}
                    handleParentChange={handleParentDropdownChange}
                />
                <Dropdown theme={theme}
                    optionsType='roles'
                    optionKey='code'
                    optionLabelKey='name'
                    value={data.is_agent}
                    valueKey='is_agent'
                    label='Role'
                    data={data}
                    handleParentChange={handleParentDropdownChange}
                />
               
                
                <DualRange theme={theme}
                    minValue={data.starting_date_min}STARTING_DATE_MIN
                    maxValue={data.starting_date_max}STARTING_DATE_MAX
                    minName='starting_date_min'
                    maxName='starting_date_max'
                    valueType='date'
                    label='Start Date'
                    handleParentChange={handleParentChange}
                />                  
                
            </React.Fragment>
        ),
    ];
    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

TeamMemberForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
    addNewItem: PropTypes.func,
};

export default TeamMemberForm;